'use strict';

angular.module('far.admin')
	.controller('MountainRouteEditController', function ($log, $http, $window, form, mountainRoutes, mountainRouteForm, showModalMessage, softdeleteable, fileUploadFilters) {
		var vm = {
			progress: true,
			mountainRouteModel: mountainRouteForm,
			getMountainRoute: getMountainRoute,
			submit: submit,
			getDocumentUrl: getDocumentUrl,
            deleted: false,
            delete: function() {
                vm.deleted = true;

                softdeleteable.delete(vm.mountainRoute.id);
            },
            restore: function() {
                vm.deleted = false;

                softdeleteable.restore(vm.mountainRoute.id);
            },
            formRoute: form('form'),
		};

		vm.mountainRouteModel.$fields.name.label = 'Название маршрута:';
		vm.mountainRouteModel.$fields.description.label = 'Описание маршрута:';
		vm.mountainRouteModel.$fields.num.label = 'Номер:';
		vm.mountainRouteModel.$fields.route_status.label = 'Классифицирован:';
		vm.mountainRouteModel.$fields.routeType.label = 'Характер маршрута:';
		vm.mountainRouteModel.$fields.routeComplexity.label = 'Категория сложности:';
		vm.mountainRouteModel.$fields.routeUser.label = 'Руководитель:';

		vm.mountainRouteModel.$fields.newRouteUserFirstName.label = 'Имя:';
		vm.mountainRouteModel.$fields.newRouteUserLastName.label = 'Фамилия:';

		vm.mountainRouteModel.$fields.mountain_peak.uiSelectOptions.onSelect = function(item, model, options) {
			if (item) { vm.mountainRoute.mountain_peaks[options.index] = item; }
		};
		vm.mountainRouteModel.$fields.routeUser.uiSelectOptions.onSelect = function (item) {
			if (item) { vm.mountainRoute.user = item; }
		};
		vm.mountainRouteModel.$fields.slidesFiles.uploader.onSuccessItem = function (item, response) {
			vm.mountainRoute.slides_files.push(response);
		};
        vm.mountainRouteModel.$fields.documentsFiles.uploader.onSuccessItem = function (item, response) {
            vm.mountainRoute.documents_files.push(response);
        };
		vm.mountainRouteModel.$fields.documentsFiles.uploader.removeFromQueue = function (value) {
			var index = this.getIndexOfItem(value);
			var item = this.queue[index];

			if (item.isUploading) {
				item.cancel();
			} else {
				vm.documents_files.splice(index, 1);
			}

			this.queue.splice(index, 1);
			item._destroy();

			this.progress = this._getTotalProgress();
		};
        vm.mountainRouteModel.$fields.camp.uiSelectOptions.onSelect = function (item) {
            vm.mountainRoute.camp = item ? item : null;
        };

        vm.formRoute
            .addField('image', 'imageUpload', {
                validators: {
                    required: false
                },
                uploader: {
                    url: Routing.generate('api_upload_post_avatar', {thumb: 'avatar_relative'}),
                    autoUpload: true,
                    removeAfterUpload: true,
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            })
        ;

        vm.formRoute.$fields.image.uploader.onSuccessItem = function (item, response) {
            vm.mountainRoute.image = response;
        };

		function getDocumentUrl(file_id) {
			return Routing.generate('api_upload_get_file', {fileStorage: file_id});
		}

		function getMountainRoute() {
			softdeleteable.setModel(mountainRoutes);

			if (arguments.length == 0) {
				vm.mountainRoute = mountainRoutes.new({
					slides_files: [],
					documents_files: []
				});
				vm.mountainRoute.mountain_peaks = [undefined];
				vm.progress = false;
			} else {
				vm.mountainRoute = mountainRoutes.get(arguments[0], function () {
					if (vm.mountainRoute.mountain_peaks.length == 0) {
						vm.mountainRoute.mountain_peaks.push();
					}
					vm.progress = false;
				});
			}
		}

		function submit() {
			// vm.mountainRoute.documents_files = vm.mountainRoute.documents_files.concat(
			// 	vm.documents_files
			// 		.filter(function (document) {
			// 			return document.isUploaded;
			// 		})
			// 		.map(function (document) {
			// 			return document.serverData;
			// 		})
			// );
			// vm.mountainRouteModel.$fields.documentsFiles.uploader.clearQueue();

			vm.mountainRoute.slides_files = vm.mountainRoute.slides_files.map(function(slide, index) {
				slide.sort = index + 1;
				return slide;
			});
			if(vm.mountainRoute.user==undefined)
                vm.mountainRoute.user=0;

			vm.mountainRoute.save()
				.then(function (response) {
					$window.location.href = Routing.generate('page_mountainroute_index', {id: response.data.id});
				})
				.catch(function (response) {
					$log.error(response);
					showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
				});
		}

		return vm;
	});